import type {
  LineItemResponseDto,
  LineItemsControllerListLineItemsParams,
} from '@trellis/api'
import type { CreateLineItem, UpdateLineItem } from '@trellis/shared'

import { apiClient } from '@/lib/api-client'
import { request, requestPaged } from '@/lib/request'

export interface LineItemSuggestion {
  id: string
  title: string
  unitPrice: number
  unitType: string
  quantity: number
  discountType: 'NONE' | 'PERCENTAGE' | 'FIXED'
  discount: number
  taxable: boolean
  description: string | null
  similarity: number
}

export type LineItemsListParams = LineItemsControllerListLineItemsParams & {
  /** Filter by tag IDs */
  tags?: string[]
}

export const listLineItems = (params: LineItemsListParams = {}) =>
  requestPaged<LineItemResponseDto>(() =>
    /* tags param accepted by server Zod schema — Swagger decorator pending backend restart */
    apiClient.api.lineItemsControllerListLineItems(
      params as LineItemsControllerListLineItemsParams,
    ),
  )

export const getLineItem = (id: string) =>
  request<LineItemResponseDto>(() => apiClient.api.lineItemsControllerGetLineItem({ id }))

export const createLineItem = (data: CreateLineItem) =>
  request<LineItemResponseDto>(() =>
    apiClient.api.lineItemsControllerCreateLineItem(data),
  )

export const updateLineItem = (id: string, data: UpdateLineItem) =>
  request<LineItemResponseDto>(() =>
    apiClient.api.lineItemsControllerUpdateLineItem({ id }, data),
  )

export const deleteLineItem = (id: string) =>
  request<void>(() => apiClient.api.lineItemsControllerDeleteLineItem({ id }))

export const assignTagsToLineItem = (lineItemId: string, tagIds: string[]) =>
  request<void>(() =>
    apiClient.api.lineItemsControllerAssignTags({ id: lineItemId }, { tagIds }),
  )

export const removeTagFromLineItem = (lineItemId: string, tagId: string) =>
  request<void>(() =>
    apiClient.api.lineItemsControllerRemoveTag({ id: lineItemId, tagId }),
  )

export const suggestLineItems = (q: string) =>
  request<LineItemSuggestion[]>(() =>
    apiClient.api.lineItemsControllerSuggestLineItems({ q }),
  )
